// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lw-3";
export var downloadButton = "_lw-4";
export var fileContainer = "_lw-9 _lw-7";
export var fileContainerBase = "_lw-7";
export var fileContainerFixedHeight = "_lw-8 _lw-7";
export var fileInfo = "_lw-5";
export var fileInfoWidthRestricted = "_lw-6";
export var fileType = "_lw-1";
export var fileTypeName = "_lw-2";
export var image = "_lw-0";
export var link = "_lw-b";
export var overflowEllipsis = "_lw-a";